import styled from 'styled-components';

export const Wrap = styled.div`
	cursor: pointer;
	i {
		color: ${props => props.theme.fontColor};
	}
`;
